import authSvc from '@efex-services/auth/authSvc';

import { updateUserPreference as updatePreference } from '@pages/profile/store';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { captureException } from '@sentry/react';
import {
  UserPreferencesKeys,
  UseUserPreferencesReturn,
} from './useUserPreferences.types';

const useUserPreferences = (): UseUserPreferencesReturn => {
  const dispatch = useDispatch();
  const profile = useSelector(selectProfileData);
  const userId = profile?.uuid;
  const userPreferences = profile?.userPreferences;

  const updateOrCreateUserPreference = useCallback(
    async (
      preference: (typeof UserPreferencesKeys)[keyof typeof UserPreferencesKeys],
      value: string | boolean
    ): Promise<void> => {
      if (!userId) return;

      const request = Object.keys(userPreferences || {}).includes(preference)
        ? authSvc.updateUserPreference(userId, preference, value)
        : authSvc.createUserPreference(userId, preference, value);

      try {
        await request;
        dispatch(updatePreference({ preference, value }));
      } catch (err) {
        captureException(err);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userId, userPreferences]
  );

  return {
    preferences: profile?.userPreferences || [],
    updateOrCreateUserPreference,
  };
};

export default useUserPreferences;
